// extracted by mini-css-extract-plugin
module.exports = {"fullPaletteCanvas":"fullPaletteCanvas_fullPaletteCanvas__1mmln","hidden":"fullPaletteCanvas_hidden__1fGEr"};